import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-030efb51"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Newbook Payment", -1))
const _hoisted_2 = { class: "payment-link-modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Already logged into Newbook? Open the booking directly.", -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-hint" }, " Not logged in? Log into Newbook first, then click Open Payment Link. ", -1))
const _hoisted_6 = ["href"]

import { ref, watch } from "vue";
import BaseModal from "@/components/BaseModal.vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { buildNewbookLinks, NewbookLinks } from "@/utils/newbookPaymentLink";


export default /*#__PURE__*/_defineComponent({
  props: {
    bookingId: null,
    facilityId: null
  },
  emits: ["modalClosed"],
  setup(__props: any) {

const props = __props as {
  bookingId: string | number;
  facilityId: string;
}





const links = ref<NewbookLinks | null>(null);
let linkRequest = 0;

watch(
  () => [props.bookingId, props.facilityId],
  async () => {
    const request = ++linkRequest;
    links.value = null;
    const result = await buildNewbookLinks(props.bookingId, props.facilityId);
    if (request === linkRequest) {
      links.value = result;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref: "modalRef",
    onModalClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('modalClosed')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (links.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _createElementVNode("a", {
                class: "btn btn-blue",
                href: links.value.paymentLink,
                target: "_blank",
                rel: "noopener noreferrer"
              }, " Open Payment Link ", 8, _hoisted_4),
              _hoisted_5,
              _createElementVNode("a", {
                class: "btn btn-white",
                href: links.value.loginLink,
                target: "_blank",
                rel: "noopener noreferrer"
              }, " Log into Newbook ", 8, _hoisted_6)
            ], 64))
          : (_openBlock(), _createBlock(BaseSpinner, { key: 1 }))
      ])
    ]),
    _: 1
  }, 512))
}
}

})